






























































































import { TreeLevelNode } from '~/models/category/types'
import { elementIsOverflownInParent } from '~/utils/dom'
import {
  faCheck,
  faChevronRight,
  faDotCircle,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
import CCategoryExternal from '~/components/shared/configurable/category/picker/CCategoryExternal.vue'
import CListGroup from '~/components/shared/configurable/list-group/CListGroup.vue'
import CListGroupItem from '~/components/shared/configurable/list-group/CListGroupItem.vue'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { mapGetters } from 'vuex'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { CCategoryExternal, CListGroup, CListGroupItem },
  props: {
    rootCategoryIds: {
      type: Array as PropType<number[]>,
      required: true
    },
    nodes: {
      type: Array as PropType<TreeLevelNode[]>,
      required: false,
      default() {
        return []
      }
    },
    selectButton: {
      type: Boolean,
      default: true
    },
    editCollapse: {
      type: Boolean,
      default: false
    },
    multiMode: {
      type: Boolean,
      default: false
    },
    showJobsLink: {
      type: Boolean,
      default: false
    },
    showPlotLink: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    showCategoryId: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icons() {
      return {
        chevronRight: faChevronRight,
        close: faTimes,
        check: faCheck,
        secondary: faDotCircle,
        externalLink: ciExternalLink
      }
    },
    activeCategory() {
      return this.nodes.find(node => node.isActive)
    },
    checkmarkTitle() {
      if (this.multiMode) {
        return this.isPrimary
          ? this.$t('primary category')
          : this.$t('secondary category')
      }
      return this.$t('final category')
    },
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    })
  },
  watch: {
    nodes: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.checkAndScrollToSelectedElement()
        })
      }
    }
  },
  mounted() {
    this.checkAndScrollToSelectedElement()
  },
  methods: {
    isRootNode(node: TreeLevelNode) {
      return this.rootCategoryIds.includes(node.id)
    },
    checkAndScrollToSelectedElement() {
      const activeCategoryId = this.activeCategory && this.activeCategory.id

      if (!activeCategoryId) {
        return
      }

      const activeElement = this.$refs[`category-${activeCategoryId}`][0]?.$el
      const parentElement = this.$refs.categoryLevel?.$el

      const overflow = elementIsOverflownInParent(activeElement, parentElement)

      if (overflow) {
        this.$nextTick(() => {
          if (overflow === 'down') {
            parentElement.scrollTop =
              activeElement.offsetTop -
              parentElement.clientHeight +
              activeElement.offsetHeight * 2
          } else {
            parentElement.scrollTop = activeElement.offsetTop
          }
        })
      }
    },
    onNodeClick(node: TreeLevelNode) {
      this.$emit('click-category', node)
    }
  }
})
